import {Dialog, Icon} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {observer} from "mobx-react";
import React from "react";

import {redMiddle} from "../../../const/color";
import {CancelButton, DeleteButton} from "../../atoms/buttons/buttons";
import {deleteDialogStore} from "./delete-dialog-store";

const DialogLayoutDiv = styled.div`
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
`;
const DialogH5 = styled.h5`
    font-size: 18px;
    margin: 0;
    text-align: center;
`;
const DialogP = styled.p`
    font-size: 14px;
    margin: 0;
    text-align: center;
    line-height: 1.7;
    > strong {
        font-weight: bold;
    }
`;
const DialogButtonLayoutDiv = styled.div`
    display: flex;
    margin-top: 20px;
    justify-content: center;
    column-gap: 10px;
`;

export const DeleteDialog = observer(() => {
    return (
        <Dialog
            isOpen={deleteDialogStore.isOpen}
            onClose={() => deleteDialogStore.close()}
            style={{padding: 0}}
        >
            <DialogLayoutDiv>
                <DialogH5>{deleteDialogStore.title}</DialogH5>
                <DialogP>
                    <Icon icon="error" color={redMiddle} />
                    <span dangerouslySetInnerHTML={{__html: deleteDialogStore.message}} />
                </DialogP>
                <DialogButtonLayoutDiv>
                    <CancelButton
                        onClick={() => deleteDialogStore.close()}
                        data-testid="delete-dialog-cancel-button"
                    >
                        キャンセル
                    </CancelButton>
                    <DeleteButton
                        isIcon={false}
                        onClick={() => deleteDialogStore.handleDelete()}
                        data-testid="delete-dialog-button"
                    >
                        削除
                    </DeleteButton>
                </DialogButtonLayoutDiv>
            </DialogLayoutDiv>
        </Dialog>
    );
});
